import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useFetch } from '../hooks/useFetch';

import Header from '../components/Layout/Header';

export default function RootPage() {
  const { email } = useSelector((state) => state.authState.loggedUser);

  useFetch(
    `https://mail-box-c1237-default-rtdb.firebaseio.com/${email.replace(
      '.',
      ''
    )}/receivedMails.json`
  );

  useFetch(
    `https://mail-box-c1237-default-rtdb.firebaseio.com/${email.replace(
      '.',
      ''
    )}/sentMails.json`
  );

  return (
    <>
      <Header />
      <section className="sm:ml-64 mt-2">
        <Outlet />
      </section>
    </>
  );
}
